import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Brand, Category, QueryLog, DashboardState } from '@/types/dashboard';

const initialState: DashboardState = {
  queryLogs: [],
  brands: [],
  categories: [],
  selectedBrand: null,
  selectedCategory: null,
  searchTerm: '',
  isLoading: false,
  totalResults: 0,
  currentPage: 1,
  products: [],
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setQueryLogs: (state, action: PayloadAction<{ results: QueryLog[]; count: number }>) => {
      state.queryLogs = action.payload.results;
      state.totalResults = action.payload.count;
    },
    setBrands: (state, action: PayloadAction<Brand[]>) => {
      state.brands = action.payload;
    },
    setCategories: (state, action: PayloadAction<Category[]>) => {
      state.categories = action.payload;
    },
    setSelectedBrand: (state, action: PayloadAction<string | null>) => {
      state.selectedBrand = action.payload;
    },
    setSelectedCategory: (state, action: PayloadAction<string | null>) => {
      state.selectedCategory = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setProducts: (state, action: PayloadAction<QueryLog[]>) => {
      state.products = action.payload;
    },
  },
});

export const {
  setQueryLogs,
  setBrands,
  setCategories,
  setSelectedBrand,
  setSelectedCategory,
  setSearchTerm,
  setLoading,
  setCurrentPage,
  setProducts,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;